<div class="menu-container">
  <div class="products-grid ">
    @for (item of products(); track $index) {
      <div (click)="viewDetail(item)" class="product-card mat-z-elevation-8 anim-fade-in-up">
        <div [ngStyle]="item.imageUrl | bgUrl" class="image-wrapper">
          @if (item.isNew) {
            <div class="item-ribbon ribbon-new">Nuevo</div>
          } @else if (item.comingSoon) {
            <div class="item-ribbon ribbon-soon">Pronto</div>
          }
        </div>
        <div class="card-content">
          <h3 class="product-name text-h3">{{ item.name }}</h3>
          <p class="product-desc text-body-small">{{ item.description | truncate }}</p>
          <div class="card-footer">
            <span class="text-price">{{ item.price | clpFormat }}</span>
            <button (click)="addToCart(item, $event)"
                    [disabled]="isOrderLocked()"
                    [style.opacity]="isOrderLocked() ? '0.5' : '1'"
                    class="btn-mini-icon accent">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    } @empty {
      <div class="empty-state">
        <mat-icon>coffee</mat-icon>
        <p>No hay productos disponibles en esta categoría.</p>
      </div>
    }
  </div>

  <footer class="view-footer anim-slide-in-up">
    <button (click)="goBack()" class="btn-outline" mat-stroked-button>
      <mat-icon>arrow_back</mat-icon>
      Volver al Menú
    </button>
  </footer>
</div>
